import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { CircleCheckbox } from '../../../../../components/_events/_manage-event/shared/circle-checkbox/circle-checkbox';
import { IAssetsSpeakersDetailsDTO } from '../../../../../api/assets.dao';
import { LONG_RICH_TEXT_LENGTH } from '../../../../../constants/common.constants';
import { AssetsBiographyFormWrapper } from '../assets-biography-form/assets-biography-form-wrapper';

import '../assets.scss';
import { ASSETS_BIOGRAPHY_TEXT, ASSETS_BIOGRAPHY_UPDATED_TEXT } from '../assets.text';

interface IAssetBiographyProps {
    accountId: number;
    eventId: number;
    organizationId: number;
    attendee: IAssetsSpeakersDetailsDTO;
    updateAttendeePermission: boolean;
    setSpeakerBiography: (biography: string, organizationId: number, attendeeId: number) => void;
}

const AssetBiographyItem = mobxReact.observer((props: IAssetBiographyProps) => {
    const {
        accountId,
        eventId,
        organizationId,
        attendee,
        updateAttendeePermission,
        setSpeakerBiography
    } = props;

    const biographyIsPresent = !!attendee?.biography;
    return (
        <tr
            key={attendee.attendeeId}
            className='assets-list-item'
        >
            <td className='hoverable'>
                <div className='assets-list-item__attendee-name'>
                    <CircleCheckbox
                        item={{ active: biographyIsPresent }}
                        handleClick={null}
                        size={20}
                        className='disabled'
                    />
                    <div className='overflow-ellipsis'>
                        {`${attendee.firstName} ${attendee.lastName} `}
                        <FormattedMessage {...ASSETS_BIOGRAPHY_TEXT} />
                    </div>
                </div>
            </td>
            <td className='hoverable'>
                <AssetsBiographyFormWrapper
                    accountId={accountId}
                    eventId={eventId}
                    organizationId={organizationId}
                    attendeeId={attendee.attendeeId}
                    biography={attendee?.biography}
                    updateAttendeePermission={updateAttendeePermission}
                    setSpeakerBiography={setSpeakerBiography}
                />
            </td>
            <td className='hoverable'>
                <div className='overflow-ellipsis assets-list-item__hint'>Rich text, max {LONG_RICH_TEXT_LENGTH} characters including HTML markup</div>
            </td>
            <td className='hoverable' />
            <td className='hoverable'>
                {attendee.isBiographyAdded && biographyIsPresent
                    && <div className='assets-list-item__added-status assets-list-item__added-status__fade-out'>
                        <CircleCheckbox
                            item={{ active: true }}
                            handleClick={null}
                            size={20}
                            className='disabled opacity-circle'
                        />
                        <span>
                            <FormattedMessage {...ASSETS_BIOGRAPHY_UPDATED_TEXT} />
                        </span>
                    </div>
                }
            </td>
        </tr>
    );

});

export { AssetBiographyItem };